// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".basket-desktop-layout{display:grid;grid-template-columns:minmax(580px,1480px) minmax(300px,420px);grid-template-areas:\"body sidebar\";grid-column-gap:60px}.basket-desktop-layout._column{display:block}.basket-desktop-layout__sidebar{grid-area:sidebar}.basket-desktop-layout__body{grid-area:body}.basket-desktop-layout__tabs-holder{border-bottom:1px solid #e6e9ed;display:flex;justify-content:space-between}.basket-desktop-layout__shelf{margin-top:60px}", ""]);
// Exports
module.exports = exports;
